module.exports = __webpack_public_path__ + "img/coupon.0bf60e6e.svg";